import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {pdfAzureActionTypes, PdfAzureSuccess} from '../actions/pdfazure';

export interface PdfAzureState {
  // tslint:disable-next-line:no-any
  url: string;
}

const initialState: PdfAzureState = {
  url : null
};

export function pdfAzureReducer(state: PdfAzureState = initialState, action: Action): PdfAzureState {
  switch (action.type) {
    case pdfAzureActionTypes.ADD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case pdfAzureActionTypes.ADD_FAIL:
      return handleLoadFailAction(state);
    case pdfAzureActionTypes.REMOVE_CLEAR:
      return handleClearAllAction();
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: PdfAzureState, action: PdfAzureSuccess): PdfAzureState {

 const newState = _.clone(state);

 if (action.payload === null) {
      return null;
    }
    else {
  const base64 = action.payload.replace(/"/g, '');

  // Convert base64 to a blob object
  const binaryData = atob(base64);
  const uint8Array = new Uint8Array(binaryData.length);
  for (let i = 0; i < binaryData.length; i++) {
    uint8Array[i] = binaryData.charCodeAt(i);
  }
  const blob = new Blob([uint8Array], { type: 'application/pdf' });

  // Display PDF in new window
  const fileURL = URL.createObjectURL(blob);
  newState.url = fileURL;

  return newState;
}
}
function handleClearAllAction(): PdfAzureState {
  return initialState;
}
function handleLoadFailAction(state: PdfAzureState): PdfAzureState {
  const newState = _.clone(state);
  newState.url = null;
  return newState;
}

export const pdfAzureSelectors = {
  url: (state: PdfAzureState) => _.get(state, 'url', null)
};
